<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        color="#FFFFFF20"
        small
        class="white--text font-weight-bold elevation-0 px-2"
        style="text-transform: none;"
        @click="emitTour"
      >
      <v-icon class="mr-2" small>fas fa-book</v-icon>
        Aprenda a usar
      </v-btn>
    </template>
    <span>Aprenda a usar</span>
  </v-tooltip>
</template>

<script>
import { EventBus } from "@/eventBus";

export default {
  name: "TourButton",
  props: {
    hash: {
      type: String,
      required: true
    }
  },
  data() {
    return {
    };
  },
  methods: {
    emitTour() {
      if (EventBus) {
        EventBus.$emit("tour", this.hash);
      }
    },
  },  
};
</script>

<style></style>
